import { useState, useEffect } from 'react'
import { fetchCustomItems } from '../api/customEndpoint'
import { get } from 'lodash'

export const VALID_ENDPOINTS = {
  brandsWithHotels: 'brands-with-hotels', // without params
  hotelsWithBrands: 'hotels-with-brands', // without params
  ourProperties: 'our-properties-custom', // valid params: { hotel_ID: 110 }
  ourVenues: 'our-venues-custom', // valid params: { venue_ID: 110 }
  bookingEngine: 'booking-engine-custom', // without params
  instagramFeed: 'instagram-feed',
  captchaVerified: 'captcha-verified',
}

const useCustomEndpoint = ({ type, params, fetchOnMount = true }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchCustomItems({ type, params })
        const jsonData = get(response, 'data', [])
        setData(jsonData)
        setLoading(false)
      } catch (error) {
        setError(error)
        setLoading(false)
      }
    }
    if (fetchOnMount) fetchData()
    else setLoading(false)
  }, [fetchOnMount])

  const reFetchData = async ({ type = type, params = params }) => {
    try {
      setLoading(true)
      const response = await fetchCustomItems({ type, params })
      const jsonData = get(response, 'data', [])
      setData(jsonData)
      setLoading(false)

      return jsonData
    } catch (error) {
      setError(error)
      setLoading(false)
    }
  }

  return { data, loading, error, reFetchData }
}

export default useCustomEndpoint
